import { render, staticRenderFns } from "./ResourcesFigma.vue?vue&type=template&id=b0d5f20e&scoped=true"
import script from "./ResourcesFigma.vue?vue&type=script&lang=js"
export * from "./ResourcesFigma.vue?vue&type=script&lang=js"
import style0 from "./ResourcesFigma.vue?vue&type=style&index=0&id=b0d5f20e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d5f20e",
  null
  
)

export default component.exports